class FiltersDrawer extends HTMLElement {
  constructor() {
    super();
    this.hideDrawer = this.hideDrawer.bind(this);
    // this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.toggleFilterByDrawer = this.toggleFilterByDrawer.bind(this);
    this.showDropdown = this.showDropdown.bind(this);
  }

  get baseUrl() {
    return this.dataset.baseUrl;
  }

  get productGridSectionId() {
    const productGrid = document.querySelector("product-grid");
    if (productGrid) {
      return productGrid.dataset.sectionId;
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
   

    this.filtersDrawer = this.querySelector(".bosFiltersDrawer");
    this.drawerOverlay = this.querySelector(".bosFiltersDrawerOverlay");

    this.filterButton = document.querySelector(".bosFilterButton");
    if (this.filterButton) {
      this.filterButton.addEventListener("click", this.toggleFilterByDrawer);
    }

    // rebind when product grid re-renders
    document.addEventListener("product-grid:updated", () => {
      this.bindEvents();
    });

    document.addEventListener("sort-drawer:updated", () => {
      this.bindEvents();
    });

    this.bindEvents();
  }

  bindEvents() {
    // Drawer overlay
    if (this.drawerOverlay) {
      this.drawerOverlay.addEventListener("click", this.hideDrawer);
    }

    // dropdowns
    this.dropdowns = this.querySelectorAll(".bosFiltersDrawerDropdown");
    if (this.dropdowns) {
      this.dropdowns.forEach((dropdown) => {
        dropdown
          .querySelector(".bosFiltersDrawerDropdownLabels")
          ?.classList.add("hidden");
        dropdown.addEventListener("click", this.showDropdown);
      });
    }

    // Filter inputs
    this.filterInputs = this.querySelectorAll(".bosFiltersDrawerInput");
    // this.filterInputs.forEach((filter) => {
    //   filter.addEventListener("change", this.handleFilterChange);
    // });

    // Submit button
    this.submitButton = this.querySelector(".bosFiltersDrawerApplyButton");
    if (this.submitButton) {
      this.submitButton.addEventListener("click", this.handleFormSubmit);
    }

    // Clear button
    this.clearButton = this.querySelector(".bosFiltersDrawerClearAllButton");
    if (this.clearButton) {
      this.clearButton.addEventListener("click", this.clearAll);
    }

    // Escape key (attach once only)
    if (!this._escapeBound) {
      this._escapeHandler = (e) => {
        if (e.key === "Escape") this.hideDrawer();
      };

      document.addEventListener("keydown", this._escapeHandler);
      this._escapeBound = true;
    }
  }

  disconnectedCallback() {
    // stop escape listener
    if (this._escapeHandler) {
      document.removeEventListener("keydown", this._escapeHandler);
    }

    // dropdowns
    if (this.dropdowns) {
      this.dropdowns.forEach((dropdown) =>
        dropdown.removeEventListener("click", this.showDropdown),
      );
    }

    // cleanup overlay
    if (this.drawerOverlay) {
      this.drawerOverlay.removeEventListener("click", this.hideDrawer);
      if (this.drawerOverlay) {
      }
    }

    // cleanup inputs
    // if (this.filterInputs) {
    //   this.filterInputs.forEach((input) => {
    //     input.removeEventListener("change", this.handleFilterChange);
    //   });
    // }

    // cleanup buttons
    if (this.submitButton) {
      this.submitButton.removeEventListener("click", this.handleFormSubmit);
    }

    // clear button
    if (this.clearButton) {
      this.clearButton.removeEventListener("click", this.clearAll);
    }

    // trigger sort drawer button
    if (this.filterButton) {
      this.filterButton.removeEventListener("click", this.toggleFilterByDrawer);
    }
  }

  // handleFilterChange(e) {
  //   return;

  //   // for checkbox change

  //   const url = e.currentTarget.checked
  //     ? new URL(e.currentTarget.dataset.addUrl, window.location.origin)
  //     : new URL(e.currentTarget.dataset.removeUrl, window.location.origin);

  //   const sections = [this.productGridSectionId, this.sectionId].join(",");

  //   url.searchParams.set("sections", sections);

  //   fetch(url.toString())
  //     .then((res) => res.json())
  //     .then((data) => {
  //       // product grid
  //       this.renderSection(
  //         data[this.productGridSectionId],
  //         this.getSectionsToUpdate(this.productGridSectionId),
  //       );

  //       // filter drawer
  //       this.renderSection(
  //         data[this.sectionId],
  //         this.getSectionsToUpdate(this.sectionId),
  //       );

  //       // rebind event listeners
  //       this.bindEvents();

  //       // clear up sections param
  //       url.searchParams.delete("sections");
  //       window.history.pushState({}, "", url.toString());
  //     })
  //     .catch((err) => console.error(err));
  // }

  handleFormSubmit(e) {
    e.preventDefault();

    // Start from current URL
    const url = new URL(window.location.href);

    // Remove all existing filter params first
    [...url.searchParams.keys()]
      .filter((key) => key.startsWith("filter."))
      .forEach((key) => url.searchParams.delete(key));

        // Re-append only the inputs that are ticked right now
    this.filterInputs?.forEach((filter) => {
      if (filter.checked && filter.name) {
        url.searchParams.append(filter.name, filter.value);
      }
    });

    // OLD
    // this.filterInputs?.forEach((filter) => {
    //   const filterUrl = filter.checked
    //     ? new URL(filter.dataset.addUrl, window.location.origin)
    //     : new URL(filter.dataset.removeUrl, window.location.origin);

    //   // Apply each param change instead of replacing the whole URL
    //   filterUrl.searchParams.forEach((value, key) => {
    //     if (value === "") {
    //       url.searchParams.delete(key);
    //     } else {
    //       url.searchParams.set(key, value);
    //     }
    //   });
    // });
    // END OLD

    // reset pagination if present
    url.searchParams.delete("page");
    url.searchParams.delete("sections");

    const sections = [this.productGridSectionId, this.sectionId].join(",");

    url.searchParams.set("sections", sections);

    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        this.renderSection(
          data[this.productGridSectionId],
          this.getSectionsToUpdate(this.productGridSectionId),
        );

        this.renderSection(
          data[this.sectionId],
          this.getSectionsToUpdate(this.sectionId),
        );

        // dispatch update event
        document.dispatchEvent(new CustomEvent("filters-drawer:updated"));
        document.dispatchEvent(new CustomEvent("product-grid:updated"));

        this.bindEvents();
        this.syncDropdownState();

        // Clean URL
        url.searchParams.delete("sections");
        window.history.pushState({}, "", url.toString());
                this.hideDrawer();
      })
      .catch(console.error);
  }

  getSectionsToUpdate(sectionId) {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return [];

    const sectionsToUpdate = section.dataset.sectionsToUpdate;
    if (!sectionsToUpdate) return [];

    return sectionsToUpdate
      .split(",")
      .map((s) => s.trim())
      .map((s) => `.${s}`);
  }

  renderSection(html, selectors) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    selectors.forEach((selector) => {
      const target = document.querySelector(selector);
      const source = temp.querySelector(selector);
      if (!target || !source) return;
      target.innerHTML = source.innerHTML;
    });
  }

  clearAll() {
    const fetchUrl = new URL(this.baseUrl, window.location.origin);
    const sections = [this.productGridSectionId, this.sectionId].join(",");
    fetchUrl.searchParams.set("sections", sections);

    fetchUrl.searchParams.delete("page");
    fetchUrl.searchParams.delete("filter");

    // preserve search term if present
    const searchQuery = new URL(window.location.href).searchParams.get("q");
    if (searchQuery) {
      fetchUrl.searchParams.set("q", searchQuery);
    }

    fetch(fetchUrl.toString())
      .then((res) => res.json())
      .then((data) => {
        this.renderSection(
          data[this.productGridSectionId],
          this.getSectionsToUpdate(this.productGridSectionId),
        );

        this.renderSection(
          data[this.sectionId],
          this.getSectionsToUpdate(this.sectionId),
        );

        // Push clean URL — base path + q if present, no filter params
        const cleanUrl = new URL(this.baseUrl, window.location.origin);
        if (searchQuery) {
          cleanUrl.searchParams.set("q", searchQuery);
        }
        window.history.pushState({}, "", cleanUrl.toString());
                this.hideDrawer();

        document.dispatchEvent(new CustomEvent("filters-drawer:updated"));
        document.dispatchEvent(new CustomEvent("product-grid:updated"));

        this.bindEvents();
      })
      .catch((err) => console.error(err));
  }

  showDropdown(e) {
    // Don't toggle the dropdown when clicking a checkbox or its label
    if (e.target.closest("label") || e.target.tagName === "INPUT") return;

    const target = e.currentTarget;
    const currentDropdown = target.querySelector(
      ".bosFiltersDrawerDropdownLabels",
    );
    const isCurrentlyHidden = currentDropdown.classList.contains("hidden");

    // Close all unchecked dropdowns
    this.syncDropdownState();

    // Toggle the clicked one
    currentDropdown.classList.toggle("hidden", !isCurrentlyHidden);
  }

  syncDropdownState() {
    this.querySelectorAll(".bosFiltersDrawerDropdown").forEach((dropdown) => {
      const labels = dropdown.querySelector(".bosFiltersDrawerDropdownLabels");
      const hasChecked = dropdown.querySelector(
        ".bosFiltersDrawerInput:checked",
      );
      hasChecked
        ? labels?.classList.remove("hidden")
        : labels?.classList.add("hidden");
    });
  }

  toggleFilterByDrawer(e) {
    const target = e.currentTarget;
    // apply is active

    target.classList.contains("isActiveDrawer")
      ? this.hideDrawer()
      : this.showDrawer();
  }

  showDrawer() {
    this.disableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.remove("hidden");
    if (this.filtersDrawer) this.filtersDrawer.classList.add("isOpen");
    this.filterButton?.classList.add("isActiveDrawer");
  }

  hideDrawer() {
    this.enableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.add("hidden");
    if (this.filtersDrawer) this.filtersDrawer.classList.remove("isOpen");
    this.filterButton?.classList.remove("isActiveDrawer");
  }

  disableScrollingBody() {
    document.body.classList.add("disableScrolling");
  }

  enableScrollingBody() {
    document.body.classList.remove("disableScrolling");
  }
}

if (!customElements.get("filters-drawer")) {
  customElements.define("filters-drawer", FiltersDrawer);
}
